import { ICreatorsItems, INichesItems, ITagsList } from "@/common/services/types";
import { useMemo } from "react";
import { searchTabsEnum } from "../Tabs";
import { CategoryResults } from "../CategoryResults";
import Skeleton from "@/common/images/icons/search-skeleton.svg?react";
import "./AllResults.scss";

interface IAllResults {
  searchValue: string;
  creators: ICreatorsItems[];
  niches: INichesItems[];
  tags: ITagsList[];
  isLoading: boolean;
}

export const AllResults = ({
  searchValue,
  creators,
  niches,
  tags,
  isLoading
}: IAllResults) => {
  const sections = useMemo(() => [
    { title: searchTabsEnum.TAGS, data: tags },
    { title: searchTabsEnum.NICHES, data: niches },
    { title: searchTabsEnum.CREATORS, data: creators },
  ].filter((section) => section.data.length > 0), [creators, niches, tags]);

  if (isLoading) {
    return <Skeleton />;
  }

  if (sections.length === 0) {
    return <p className="noResults">No results found.</p>;
  }

  return (
    <div className="allResults">
      {sections.map(({ title, data }) => (
        <CategoryResults
          key={title}
          searchValue={searchValue}
          data={data}
          title={title}
          activeTab={title as Exclude<searchTabsEnum, searchTabsEnum.ALL>}
        />
      ))}
    </div>
  );
};
